// Used to determine whether to render a
// standard style or a style tailored to
// the Dasher landing page
export enum SimpleStyleType {
  Standard = 'standard',
  Landing = 'landing',
}
